import "@lds/core/lds-select.js"
import "@lds/core/lds-option.js"
import "@lds/core/lds-dropdown.js"

import "../global/pagination/pagination.css"
import "../azm/advert-cards.css"

import "./pagination/pagination.ts"
import "./pagination/index.ts"
import "./pagination/buttons.ts"
import "./pagination/select.ts"

import "@modules/util/Scrolling.ts"

import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"

setAZMFilterPath()
